export default {
    tabbar: {
        home: 'Página inicial',
        trading: 'transacção',
        invest: 'investimento',
        share: 'share',
        mine: 'meu'
    },
    common: {
        deposit: 'depósito',
        withdrawal: 'desenho',
        share: 'share',
        team: 'equipa',
        task: 'tarefa',
        addr: 'Endereço',
        logout: 'Cancelamento',
        wallet: 'carteira',
        account: 'conta',
        promotion: 'extensão',
        details: 'detalhes',
        dailyRevenue: 'Receitas diárias',
        dailyRevenueList: 'Lista de receitas diárias',
        aboutUs: 'Sobre nós',
        globalPartners: 'Parceiros globais',
        totalBalance: 'Saldo total',
        profitList: 'Lista de receitas financeiras',
        notification: 'aviso',
        previous: 'Anterior',
        close: 'fechar',
        next: 'Próximo',
        investWallet: 'Carteira de Investimento',
        financialWallet: 'Carteira Financeira',
        recharge: 'Recarregar',
        copySucceeded: 'A cópia foi bem sucedida',
        copyFailed: 'a cópia falhou',
        promotionWallet: 'Carteira Promocional',
        registerRewardWallet: 'Registar a Carteira de Recompensas',
        toAddress: 'Endereço da carteira TRON para coleta (começando por T)',
        verifyYourPassword: 'Verificar a sua senha',
        serviceFee: 'Gas fees',
        confirm: 'confirmar',
        submitted: 'Enviado',
        date: 'data',
        amount: 'montante de dinheiro',
        accountAvailableBalance: 'Saldo disponível na conta',
        securityPassword: 'Senha de segurança',
        withdrawalPrincipal: 'Retirada do capital',
        withdrawalProfit: 'Retirada dos lucros',
        profitRate: 'Taxa de juro',
        notificationAndFAQ: 'FAQ e Avisos',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Características/introdução do projeto',
                content: `R:
1. Sendo o primeiro e comprovado código de investimento auditado do setor, nossa solução visa provar que os contratos inteligentes são o futuro do investimento. A sua longevidade e estabilidade acabarão por perturbar a indústria criptográfica e a forma como as pessoas pensam sobre investimento e negociação. A indústria de tokens convencionais enfrenta muitos desafios, incluindo fraudes de tokens, tapetes, volatilidade do mercado, desenvolvedores desonestos que roubam fundos dos usuários e falta de liquidez.

2. O código de confiabilidade que temos é baseado na estrutura da solução e nossa solução não será afetada de forma alguma por esses e muitos outros desafios que surgem na indústria de criptografia. Nossa plataforma não requer liquidez de mercado. Portanto, seu investimento e rendimento esperado estão seguros porque não dependemos de mudanças no setor. Em vez disso, construímos uma solução baseada no apelo de novos usuários, mas rodando em contratos inteligentes! Nosso código e estrutura são seguros, com longevidade e transparência garantidas. Portanto, temos um programa de referência muito atrativo e robusto, com estatísticas detalhadas e transparentes para cada promotor/usuário. Os ganhos do originador, bem como de outros usuários, são adicionados instantaneamente ao perfil e, ao contrário de outras soluções de investimento DeFi, as pessoas podem sacar fundos instantaneamente a qualquer momento.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:Qual é a nossa vantagem?',
                content: `R:Nossos sistemas são auditados pela equipe de segurança da Haze e contam com auditores independentes de Smart Contract
1. Seguro e confiável: não há necessidade de transferir moeda, o USDT é depositado em sua própria carteira sem risco
2. Estabilidade profissional: equipe profissional, operação estável ao longo do ano
3. Limite de entrada baixo: compartilhe a receita de mineração do nó
4.Pool de mineração USD ETHW AI Strategy-C: Não há necessidade de transferência de moeda, renda estável
5. Estamos comprometidos em construir a maior plataforma DeFi integrada do mundo, DEX, IMO e DAO`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Como posso me envolver?',
                content: `R:
1. A carteira está na corrente e a estação da carteira está equipada com um navegador Dapp.
2. Conecte TRC20 ao USDT e deposite em sua carteira
3. Entre em Gongwang através do navegador da carteira
4. Sua carteira deve ter mais de 30 trx como taxas de mineração para participar deste projeto
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Quanto tempo leva para participar da mineração?',
                content: `R:O tempo não pode ser calculado. Normalmente pode ser concluído em 4 horas. Se forem encontradas outras razões incertas, o prazo poderá ser prorrogado.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Por que precisamos pagar taxas de mineração para sacar os lucros?',
                content: `R:Porque neste processo de participação na mineração os clientes são contabilizados apenas pelo nome e as taxas de mineração geradas são pagas pelos mineradores. A renda gerada está, na verdade, no pool de contratos e somente pagando taxas de mineração você pode trocá-la por renda.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Como retirar lucros?',
                content: `R:Após obter o USDT, você deve ter uma pequena quantia de TRX em sua carteira para taxas de transação. Você só precisa pagar uma vez e a troca do USDT será concluída dentro de um dia útil legal. Quando você inicia um saque, o saque em USDT será enviado automaticamente para o endereço da carteira do nó ao qual você ingressou. Outros endereços não são suportados.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:O que é mineração de liquidez Defi?',
                content: `R:A mineração de liquidez é um tipo de financiamento descentralizado DeFi. Ele não precisa comprar placas gráficas, contribuir com poder de computação ou pagar contas caras de eletricidade, mas obtém renda fornecendo fundos e liquidez. Especialmente recentemente, os preços das moedas flutuaram muito. Para alguns detentores de moedas comprometidos, a mineração de liquidez é uma forma de obter renda e acumular mais criptomoedas sem a necessidade de transações.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:Como funciona?',
                content: `R:Nossa solução é um acordo de transação informatizado que aplica automaticamente os termos de um contrato entre duas partes. Semelhante aos contratos universais, ambos os usuários da nossa plataforma devem definir as regras e termos de participação ao negociar. Uma vez alcançado um acordo e lançado um contrato inteligente, este funciona conforme concebido, com zero hipóteses de alterações nas condições pré-determinadas. Quando um usuário inicia uma atividade no pool de mineração de um nó blockchain, deve haver saldo disponível no contrato. Os demais usuários deixam a execução do contrato, não precisando mais esperar longas horas para verificar quando vender ou comprar. Portanto, de acordo com os termos do contrato, é garantido que o valor do seu investimento nunca diminuirá; pelo contrário, traz 100% de lucro aos nossos usuários.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'O valor da retirada deve ser maior que a taxa do gás consumida',
        supportTips: 'Caro usuário: Criamos um serviço exclusivo de assistente de pool de mineração para você. Você pode nos escrever para consultas, reclamações, sugestões, etc., e nós responderemos e atenderemos em 24 horas!',
        tips: 'Pontas',
        Withdrawals_prohibited: 'As condições de retirada não foram atendidas no momento, conclua a tarefa primeiro.'
    },
    homePage: {
        theCommonProblem: 'problema comum',
        latestAnnouncement: 'Último anúncio',
        block5title: 'Junte-se para se tornar um milionário Tron',
        block5desc: 'Use mineração em nuvem e tecnologia defi para garantir que todos os usuários obtenham a maior receita USDT.。',
        block6title: 'Rendimentos acumulados',
        accumulatedProfit: 'Rendimentos acumulados',
        membership: 'Rendimentos acumulados',
        block7title: 'membro',
        block7desc: 'hako é uma empresa registrada em Cingapura, número de licença: PS20200556. Somos o único site de investimento em contratos inteligentes auditado e verificado no espaço de criptomoedas operando na rede TRON Smart Chain (TRON). A mineração em nuvem hako oferece um pipeline de mineração potencialmente econômico para Bitcoin USDT e outras criptomoedas. Ao mesmo tempo, tanto a negociação quantitativa quanto a tecnologia DeFi permitirão que você participe facilmente de transações blockchain com uma pequena quantidade de capital e obtenha renda estável, como seguros.',
        tzl: 'investido',
        zl: 'Ganhou'
    },
    investPage: {
        productList: 'Lista de produtos',
        investedList: 'Lista de investimentos',
        dailyRate: 'Taxa de juro diária',
        cycle: 'ciclo',
        day: 'dia',
        productDetails: 'Detalhes do produto'
    },
    tradingPage: {
        miningWorking: 'A mineração em nuvem está funcionando',
        tradingProfit: 'Receitas de transacções',
        settlementRule: 'liquidação 24 horas',
        viewAll: 'Ver tudo',
        quantifyingTransactionRevenue: 'Renda comercial qualitativa',
        receive: 'receber',
        received: 'Recebido',
        rule: 'Regras de mineração',
        rules: 'Se você deseja que o "Cloud Mining" comece a funcionar e ganhe renda diária, ative-o em "Carteira Financeira". Quando o saldo de USDT em sua carteira atender a determinadas condições, você receberá uma renda diária e a renda gerada será retida por 30 dias. Clique para reivindicá-lo a tempo. Calcule sua porcentagem de receita diária com base na tabela abaixo:',
        profit: 'Lucro',
        miningNotWorking: 'A mineração em nuvem não está funcionando, ative-a',
        balance: 'equilíbrio'
    },
    sharePage: {
        text1: 'Convidar os seus contactos',
        text2: 'Ou amigos e receber recompensas',
        text3: 'Recomendar e receber recompensas',
        text4: 'Compartilhe seus links recomendados e comece a ganhar dinheiro',
        copyLink: 'Copiar a ligação'
    },
    minePage: {
        trxDepositInvestment: 'Depósito de investimento USDT',
        trxDepositFinancial: 'Depósito financeiro USDT',
        tips: 'Deposite qualquer número de USDT para ativar a conta e ativar a função de saque',
        appServices: 'serviço de aplicação'
    },
    depositPage: {
        text1: 'Existem dois modos de investimento',
        text2: '1:Recarregar na carteira de investimento, você pode obter renda de acordo com ciclos diferentes, e retornar o principal e renda na maturidade',
        text3: '2: Ative a função "mineração em nuvem" em sua carteira financeira e receba receitas de acordo com o fuso horário de Cingapura (após 12 horas) todos os dias',
        text4: 'notas:',
        text5: 'Antes de investir, escolha uma conta de investimento ou conta financeira de acordo com suas necessidades de investimento. Por favor, certifique-se de esperar que a conta recarregue. Esta é uma questão muito crítica.。'
    },
    rechargePage: {
        trxAddress: 'Endereço TRC20-USDT',
        copyAddress: 'Copiar o endereço',
        tips1: 'Por favor, não recarregue outros ativos que não sejam USDT. Grave cerca de 5 ~ 10 minutos após a recarga.',
        tips2: 'Se não foi entregue há muito tempo, atualize esta página. Investimento mínimo de 5 USDT.',
        rechargeCompleted: 'Recarga concluída',
        inactivated: 'Inativada',
        activated: 'Ativada',
        tips3: 'Não há necessidade de clicar repetidamente. A mineração em nuvem começa a funcionar cerca de 5 a 10 minutos após o envio da solicitação.',
        tips4: 'Se não tiver sido ativado há muito tempo, clique no botão ativar novamente.',
        ActivateCloudMining: 'Ative a mineração em nuvem'
    },
    withdrawalPage: {
        text1: 'Saldo básico da conta (USDT)',
        text2: 'A retirada será recebida dentro de 24 horas',
        dailyWithdrawalLimit: 'Limite diário de retirada',
        unlimit: 'ilimitado	'
    },
    teamPage: {
        intro: 'Os usuários que você convida direta e indiretamente podem ganhar dividendos para você. Suponha que você convide o usuário A, a receita financeira obtida pelo usuário A será enviada para sua carteira como uma recompensa percentual. Se o usuário A convidar o usuário B e B, por sua vez, convidar C, você poderá obter A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%) recompensa percentual da renda do usuário!',
        level: 'Hierarquia',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'número',
        rewards: 'recompensa'
    },
    productDetailsPage: {
        startingAmount: 'Montante inicial',
        maxInvestmentAmount: 'Investimento máximo',
        dailyInterestRate: 'Taxa de juro diária',
        investableQuantity: 'Quantidade investida',
        investmentAmount: 'Montante do investimento',
        participateInInvestment: 'Participação no investimento'
    },
    investedListPage: {
        investmentTime: 'Tempo de investimento',
        settlementTime: 'Tempo de liquidação',
        settlementAmount: 'Montante da liquidação'
    },
    loginPage: {
        MobileNumber: 'número de telefone',
        LoginPassword: 'Senha de autenticação',
        SignIn: 'Entrar',
        SignUp: 'registo',
        rememberThePassword: ' Lembrar a senha',
        inviteCode: 'Código do convite',
        captcha: 'Código de verificação',
        EncryptedRegistration: 'Registo de cifra',
        desc: 'As senhas são armazenadas em um pipeline descentralizado e não podem ser recuperadas após serem perdidas. Por favor, lembre-se da sua senha. ',
        registerSuccess: 'Conta criada com sucesso'
    },
    taskPage: {
        desc: 'Cada valor efetivo de recarga dos membros subordinados que você convidar para registrar será convertido em seu limite de retirada (conta de recompensa de promoção) em uma determinada proporção',
        rwconvertRate: 'Escala de conversão',
        totalLimit: 'Limite cumulativo',
        availableLimit: 'Crédito Disponível',
        contactService: 'Contactar o serviço de apoio ao cliente'
    },
    Please_unlock_your_wallet: 'Por favor, desbloqueie sua carteira',
    Please_open_the_website_in_the_Dapp_browser: 'Por favor, abra o site no navegador Dapp'
}
